import React from 'react';
interface CTAButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  href?: string;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className,
  href,
  variant = 'primary',
  fullWidth = false,
  ...props
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-extrabold uppercase tracking-wide transition-all duration-300 transform hover:scale-105 active:scale-95 rounded-lg py-3 px-6 text-sm md:text-base leading-none';
  const variants = {
    primary: 'bg-[#2563eb] hover:bg-[#1d4ed8] text-white border-b-3 border-[#1e40af] glow-blue',
    secondary: 'bg-[#eab308] hover:bg-[#ca8a04] text-black border-b-3 border-[#a16207] glow-yellow'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  if (href) {
    return <a href={href} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-30">
        {children}
      </a>;
  }
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className || ''}`} {...props} data-id="element-31">
      {children}
    </button>;
}